import React from 'react';
import { Page } from '../Page';
import { Target, Scale } from 'lucide-react';
export function Page2b() {
  return <Page pageNumber={7} variant="light" data-id="element-383">
      <div className="flex flex-col h-full" data-id="element-384">
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-385">
          <img src="https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=1000&q=80" alt="Cooking and food preparation" className="w-full h-full object-cover object-center" data-id="element-386" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-387" />
        </div>

        <div className="mb-8" data-id="element-388">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-389">
            The Fundamentals
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-390">
            Calories, Carbs
            <br data-id="element-391" />
            <span className="text-tealslate" data-id="element-392">and Fat</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-393" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-10" data-id="element-394">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-395">
            While protein, vitamins, omega-3s, and fiber form your foundation,
            you still need to understand the rest of your diet. You don't need
            to obsess over these numbers, but you do need to know how they work.
          </p>
          <div className="border-l-4 border-tealslate pl-6 py-3" data-id="element-396">
            <p className="text-base font-serif italic text-[#1F1F1F] leading-relaxed" data-id="element-397">
              "Your body needs energy to function. GLP-1s reduce your appetite,
              but they don't change your biological need for fuel."
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 mb-10" data-id="element-398">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-399">
            <div className="w-10 h-10 rounded-full bg-tealslate/20 border border-tealslate/40 flex items-center justify-center mb-4" data-id="element-400">
              <Target className="w-5 h-5 text-tealslate" data-id="element-401" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-3" data-id="element-402">Calories</h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-403">
              When your medication dose is appropriate, you are already in a
              calorie deficit. Tracking becomes useful when progress stalls or
              when preparing to transition off medication.
            </p>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6" data-id="element-404">
            <div className="w-10 h-10 rounded-full bg-navyslate/40 border border-navyslate/60 flex items-center justify-center mb-4" data-id="element-405">
              <Scale className="w-5 h-5 text-tealslate" data-id="element-406" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-3" data-id="element-407">
              Carbs and Fat
            </h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-408">
              Carbohydrates regulate themselves when meals are built around
              protein and fiber-rich foods. Fat is essential for hormones and
              brain function, but most protein sources naturally provide it.
            </p>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-409">
          <p className="text-sm text-[#3B3B3B] leading-[1.8] border-l-2 border-[#D8D8D0] pl-6" data-id="element-410">
            Tracking can be a helpful habit, but it is not required for success
            on GLP-1 medication. If you choose to track, use it as a tool. If
            you do not, focus on the foundational habits that drive results.
          </p>
        </div>
      </div>
    </Page>;
}